import React, { FC, ReactElement } from 'react'
import style from './UserAgreements.module.css'

type UserAgreementsProps = {
  children: ReactElement
}

export const UserAgreements: FC<UserAgreementsProps> = ({ children }) => (
  <div className={style.userAgreements}>{children}</div>
)
